import * as ActionsTypes from "../../constants/stateConstants";

/*--------------------------------------------LOCAL-REFERENTIEL------------------------------------------------*/
export const localReferentielAction = (referentielKey) => {
  return {
    type: ActionsTypes.LOCAL_REFERENTIEL,
    referentielKey,
  };
};

export const localReferentielSuccessAction = (referentielKey) => (payload) => {
  return {
    type: ActionsTypes.LOCAL_REFERENTIEL_SUCCESS,
    referentielKey,
    payload,
  };
};

export const localReferentielFailAction = (referentielKey) => (payload) => {
  return {
    type: ActionsTypes.LOCAL_REFERENTIEL_FAIL,
    referentielKey,
    payload,
  };
};
